import { Component } from '@angular/core';

@Component({
  selector: 'app-condicoes-qualidade',
  standalone: true,
  imports: [],
  templateUrl: './condicoes-qualidade.component.html',
  styleUrl: './condicoes-qualidade.component.scss',
})
export class CondicoesQualidadeComponent {}
